import {DomainEvent} from './DomainEvent';
import {StreamEntry} from '../resources/StreamEntry';

export class StreamEntryCreated extends DomainEvent<StreamEntry> {

}
